module.exports = __webpack_public_path__ + "static/93a42e0c78d544219c1a10e402ca77f3cbf6bea7a220f38a0d2c8df7ad006782-1efbbf09ac1f5fda90d4664fc1e603dc.jpeg";